module.exports = __webpack_public_path__ + "static/media/solo72.a043eb21.JPG";